import { Paper as MuiPaper } from "@mui/material"
import { alpha, styled } from "@mui/material/styles"

// Enhanced Paper with subtle gradient and better shadows
export const Paper = styled(MuiPaper)(({ theme }) => ({
	width: "100%",
	boxShadow: "0px 2px 8px " + alpha(theme.palette.common.black, 0.08),
	display: "flex",
	flexDirection: "column",
	overflow: "hidden",
	borderRadius: theme.shape.borderRadius * 1.5,
	border: `1px solid ${alpha(theme.palette.divider, 0.05)}`,
	background:
		theme.palette.mode === "dark"
			? `linear-gradient(145deg, ${alpha(theme.palette.background.paper, 0.96)}, ${alpha(theme.palette.background.paper, 1)})`
			: `linear-gradient(145deg, ${alpha(theme.palette.background.paper, 0.96)}, ${alpha(theme.palette.background.paper, 1)})`,
	backdropFilter: "blur(8px)",
	transition: theme.transitions.create(["box-shadow", "transform"], {
		duration: theme.transitions.duration.standard,
	}),
}))
